import { Toast } from "primereact/toast";
import "primereact/resources/themes/saga-orange/theme.css";
import "primeicons/primeicons.css";
import "../../../node_modules/primeflex/primeflex.css";
import { useEffect, useMemo, useRef, useState, useContext } from "react";
import Spinner from "../../components/spinner/spinner";
import { Form, Formik } from "formik";
import styles from "./DuplicateOrdersSummary.module.scss";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import * as constants from "../../constants/constants";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatDate } from "../../constants/constants";
import * as Yup from "yup";
import {
  duplicateLineItemsSummaryColumns,
  duplicateOrdersSummaryColumns
} from "../../constants/table-columns/tableColumns";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../store/action-creators";
import LoginUserDataContext from "../../store/login";
import { getDuplicateOrders } from "../../services/BajaOrderService";
import { appInsights } from "../../AppInsights";
import { Dialog } from "primereact/dialog";
import { sortData } from "../../constants/dataSort";
import { useFormik } from "formik";
import { Tag } from "primereact/tag";

export default function DuplicateOrdersSummary() {
  const toast = useRef(null);
  const toastTopRight = useRef(null);
  const formRef = useRef(null);
  const [disableFields, setDisableFields] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [duplicateOrders, setDuplicateOrders] = useState([]);
  const [selectedDuplicateOrders, setSelectedDuplicateOrders] = useState([]);
  const [allExpanded, setAllExpanded] = useState(false);
  const [expandedRows, setExpandedRows] = useState(null);
  const [defaultRegion, setDefaultRegion] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [currentPageRows, setCurrentPageRows] = useState(10);

  appInsights.trackPageView({
    name: "Duplicate Orders Summary screen visited"
  });

  const [userData, setUserData] = useContext(LoginUserDataContext);
  const dispatch = useDispatch();
  const { getRegions } = bindActionCreators(actionCreators, dispatch);

  const regions = [
    { "regionId": 42, "destination": "D365", "regionName": "tbcp", "regionNameAbbr": "TBCP", "isActive": true, "createdBy": null, "modifiedBy": null, "createdDateUtc": "0001-01-01T00:00:00", "modifiedDateUtc": null },
    { "regionId": 47, "destination": "D365", "regionName": "tfnw", "regionNameAbbr": "TFNW", "isActive": true, "createdBy": null, "modifiedBy": null, "createdDateUtc": "0001-01-01T00:00:00", "modifiedDateUtc": null },
    { "regionId": 49, "destination": "D365", "regionName": "tffl", "regionNameAbbr": "TFFL", "isActive": true, "createdBy": null, "modifiedBy": null, "createdDateUtc": "0001-01-01T00:00:00", "modifiedDateUtc": null },
    { "regionId": 50, "destination": "D365", regionName: "tfsw", regionNameAbbr: "TFSW", isActive: true },
    ,
    {
      "regionId": 5,
      "destination": "D365",
      "regionName": "Taylor Farms - Tennessee",
      "regionNameAbbr": "TFTN",
      "isActive": true,
      "createdBy": null,
      "modifiedBy": null,
      "createdDateUtc": "0001-01-01T00:00:00",
      "modifiedDateUtc": null
    },
    {
      "regionId": 43,
      "destination": "D365",
      "regionName": "tftx",
      "regionNameAbbr": "TFTX",
      "isActive": true,
      "createdBy": null,
      "modifiedBy": null,
      "createdDateUtc": "0001-01-01T00:00:00",
      "modifiedDateUtc": null
    }
  ];

  const processingStatusFormat = (rowData) => {
    let severityValue = "";
    switch (rowData.processingStatusId) {
      case constants.emailOrdersApprovalStatusOptions.Approved:
        severityValue = "success";
        break;
      case constants.emailOrdersApprovalStatusOptions.Rejected:
        severityValue = "danger";
        break;
      case constants.emailOrdersApprovalStatusOptions.Pending:
        severityValue = "secondary";
        break;
      case constants.emailOrdersApprovalStatusOptions.Submitted:
        severityValue = "info";
        break;
      case constants.emailOrdersApprovalStatusOptions.Processed:
        severityValue = "info";
        break;
      case constants.emailOrdersApprovalStatusOptions.Failed:
        severityValue = "danger";
        break;
      case constants.emailOrdersApprovalStatusOptions.Cancelled:
        severityValue = "info";
        break;
      default:
        severityValue = "";
        break;
    }
    return (
      <div>
        <Tag
          severity={severityValue}
          value={
            constants.emailOrdersApprovalStatusKeyValueOptions[rowData.processingStatusId]
          }
          rounded
        ></Tag>
      </div>
    );
  };

  const initialValues = useMemo(
    () => ({
      region: regions[0],
      orderDateFrom: new Date(),
      orderDateTo: new Date()
    }),
    []
  );

  const validationSchema = Yup.object()
    .shape({
      orderDateFrom: Yup.date().nullable().typeError("Invalid start date"),
      orderDateTo: Yup.date().nullable().typeError("Invalid end date"),
      region: Yup.object().nullable().required("Region is required")
    })
    .test(
      "dates-required-together",
      "Start and End Date are required together",
      function (values) {
        const { orderDateFrom, orderDateTo } = values || {};

        const startSelected = !!orderDateFrom;
        const endSelected = !!orderDateTo;

        if (
          (startSelected && !endSelected) ||
          (!startSelected && endSelected)
        ) {
          return this.createError({
            path: !startSelected ? "orderDateFrom" : "orderDateTo",
            message: "Both Start and End Date must be selected together"
          });
        }

        return true;
      }
    );


  const fetchDuplicateOrders = async (values) => {
    try {
      let formData = {};
      setShowSpinner(true);
      formData = {
        region: values?.region?.regionNameAbbr
          ? values?.region?.regionNameAbbr
          : null,
        startDate: values?.orderDateFrom
          ? formatDate(values?.orderDateFrom)
          : null,
        endDate: values?.orderDateTo ? formatDate(values?.orderDateTo) : null
      };
      let result = await getDuplicateOrders(formData);
      setDuplicateOrders(result);
      setSelectedDuplicateOrders([]);
      setShowSpinner(false);
    } catch (error) {
      setShowSpinner(false);

      setDuplicateOrders([]);

      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.message,
        life: 4000
      });
      appInsights.trackException({
        exception: error,
        properties: {
          additionalInfo: "Exception while Fetching Duplicate orders"
        },
        measurements: {
          severityLevel: 2
        }
      });
    }
  };

  const rowExpansionTemplate = (data) => {
    return (
      <div className="p-1 pl-5 ml-5">
        <DataTable
          value={data?.duplicatedSalesOrderLineItems}
          scrollable
          paginator={constants.paginator}
          rows={constants.defaultRows}
          rowsPerPageOptions={constants.rowsPerPageOptions}
          paginatorTemplate={constants.paginatorTemplate}
          currentPageReportTemplate={constants.currentPageReportTemplate}
          emptyMessage={constants.emptyMessage}
        >
          {duplicateLineItemsSummaryColumns?.map((col, index) => (
            <Column
              key={index}
              field={col.field}
              header={col.header}
              sortable={col.sort}
              style={{ minWidth: col.minWidth }}
              body={col.value}
              headerStyle={{ minWidth: col.minWidth }}
              paginatorTemplate={constants?.paginatorTemplate}
              paginator={constants?.paginator}
              rows={constants?.defaultRows}
              rowsPerPageOptions={constants?.rowsPerPageOptions}
              currentPageReportTemplate={constants?.currentPageReportTemplate}
            />
          ))}
        </DataTable>
      </div>
    );
  };

  const toggleRows = () => {
    if (allExpanded) {
      setExpandedRows(null);
      setAllExpanded(false);
    } else {
      let newExpandedRows = {};
      duplicateOrders.forEach((p) => (newExpandedRows[`${p?.id}`] = true));
      setExpandedRows(newExpandedRows);
      setAllExpanded(true);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    formRef.current.setFieldValue("region", regions[0]);
    fetchDuplicateOrders({ ...initialValues, region: regions[0] });
  }, []);

  const d365StatusFormat = (rowData) => {
    let severityValue = "";
    if (!rowData?.d365Status?.trim()) return;
    switch (rowData.d365Status) {
      case constants.emailOrdersD365StatusOptions.Enqueued:
        severityValue = "secondary";
        break;
      case constants.emailOrdersD365StatusOptions.InProcess:
        severityValue = "info";
        break;
      case constants.emailOrdersD365StatusOptions.ProcessedWithErrors:
        severityValue = "danger";
        break;
      case constants.emailOrdersD365StatusOptions.Processed:
        severityValue = "success";
        break;
      default:
        severityValue = "warning";
        break;
    }
    if (rowData?.d365Status == null) return;
    return (
      <div>
        <Tag severity={severityValue} value={rowData?.d365Status} rounded></Tag>
      </div>
    );
  };

  const errorBodyTemplate = (rowData) => {
    return rowData?.message;
  };

  return (
    <>
      {showSpinner && <Spinner />}
      <div className="grid pt-2">
        <div className="col-12 ">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) => {
              setShowSpinner(true);
              setExpandedRows(null);
              setAllExpanded(false);
              setCurrentPage(0);
              setCurrentPageRows(10);
              fetchDuplicateOrders(values);
            }}
            innerRef={formRef}
          >
            {({
              values,
              handleChange,
              handleSubmit,
              errors,
              touched,
              setFieldValue,
              resetForm
            }) => (
              <Form onSubmit={handleSubmit} ref={formRef}>
                <div className="grid p-fluid">
                  <div className="col-12 md:col-2">
                    <div className={styles?.formLabelContainer}>
                      <label
                        htmlFor="region"
                        style={{ marginBottom: "0.5rem", display: "block" }}
                      >
                        <span className={styles?.formLabel}>Region</span>
                      </label>
                    </div>
                    <Dropdown
                      id="region"
                      placeholder="Region"
                      value={values.region}
                      onChange={(e) => setFieldValue("region", e?.value)}
                      options={regions}
                      filter
                      optionLabel="regionNameAbbr"
                      className={`${styles.dropdown} ${styles.formControl}`}
                    />
                    {touched.region && errors.region && (
                      <small className="p-error">{errors.region}</small>
                    )}
                  </div>
                  <div className="col-12 md:col-4">
                    <div className={styles.formLabelContainer}>
                      <label htmlFor="orderDateFrom">
                        <span className={styles.formLabel}>Select Date Range</span>
                      </label>
                    </div>

                    {/* Flex container for two calendars */}
                    <div className="flex gap-2">
                      {/* Start Date */}
                      <div className="flex-1">
                        <Calendar
                          id="orderDateFrom"
                          value={values?.orderDateFrom}
                          onChange={handleChange}
                          disabled={disableFields}
                          placeholder="Start Date"
                          maxDate={values?.orderDateTo}
                        />
                        {touched.orderDateFrom && errors.orderDateFrom && (
                          <small className="p-error">{errors.orderDateFrom}</small>
                        )}
                      </div>

                      {/* End Date */}
                      <div className="flex-1">
                        <Calendar
                          id="orderDateTo"
                          value={values?.orderDateTo}
                          onChange={handleChange}
                          disabled={disableFields}
                          placeholder="End Date"
                          minDate={values?.orderDateFrom}
                        />
                        {touched.orderDateTo && errors.orderDateTo && (
                          <small className="p-error">{errors.orderDateTo}</small>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-12 md:col-6 gap-3" style={{ marginTop: "2.5rem" }}>
                    <div className="grid">
                      <div className="col-12 md:col-3 ">
                        <Button
                          label="Search"
                          type="submit"
                          size="medium"
                          className={styles?.primaryBtn}
                        />
                      </div>
                      <div className="col-12 md:col-3 ">
                        <Button
                          label="Reset"
                          type="button"
                          size="medium"
                          onClick={() => {
                            setExpandedRows(null);
                            setAllExpanded(false);
                            setCurrentPage(0);
                            setCurrentPageRows(10);
                            resetForm();
                            formRef.current.setValues({
                              orderDateFrom: new Date(),
                              orderDateTo: new Date(),
                              region: regions[0]
                            });
                            setDuplicateOrders([]);
                            setDisableFields(false);
                            fetchDuplicateOrders({ ...initialValues, region: regions[0] });
                          }}
                          className={styles?.resetBtn}
                        />
                      </div>
                    </div>
                    <div className="grid lg:mr-0">
                      <div className="col-12" >
                        <div className={styles.recordLimit}>
                          <span>
                            <i className={`${styles.recordLimit} pi pi-info-circle p-0`} style={{ fontSize: '10px', marginBottom: "0.5rem" }}></i>
                            {" "} Fetching latest 5000 records only
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>

      <div className="mt-4">
        <DataTable
          value={duplicateOrders}
          tableStyle={{ minWidth: "50rem" }}
          scrollable
          paginator={constants.paginator}
          first={currentPage}
          onPage={(e) => { setCurrentPage(e.first); setCurrentPageRows(e?.rows) }}
          rows={currentPageRows}
          rowsPerPageOptions={constants.rowsPerPageOptions}
          paginatorTemplate={constants.paginatorTemplate}
          currentPageReportTemplate={constants.currentPageReportTemplate}
          emptyMessage={constants.emptyMessage}
          dataKey="id"
          scrollHeight="30vw"
          selectionMode="checkbox"
          selection={selectedDuplicateOrders}
          onSelectionChange={(e) => setSelectedDuplicateOrders(e.value)}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          rowExpansionTemplate={rowExpansionTemplate}
        >
          <Column
            header={
              <Button
                className={
                  allExpanded ? "pi pi-angle-down" : "pi pi-angle-right"
                }
                style={{
                  fontSize: "1.3rem",
                  color: "#6c757d",
                  backgroundColor: "#f8f9fa",
                  border: "none",
                  padding: "2px"
                }}
                onClick={toggleRows}
              ></Button>
            }
            style={{ width: "10px" }}
            expander={true}
          />

          {duplicateOrdersSummaryColumns.map((col, index) => (
            <Column
              key={index}
              field={col.field}
              header={col.header}
              sortable={col.sort}
              style={{ minWidth: col.minWidth }}
              headerStyle={{ minWidth: col.minWidth }}
              body={
                col?.field?.toLocaleLowerCase() === "d365status"
                  ? d365StatusFormat
                  : col?.field?.toLocaleLowerCase() === "message"
                    ? errorBodyTemplate
                    : col?.field?.toLocaleLowerCase() === "processingstatusid"
                      ? processingStatusFormat
                      : col?.value || null
              }
            />
          ))}
        </DataTable>
      </div>

      <Toast ref={toast} position="center" />
      <Toast ref={toastTopRight} position="top-right" />
    </>
  );
}
